import type { Nullable } from 'modules/global/typing/common/common';
import * as types from 'modules/statistics/actionTypes';
import type { FetchAuditInFilesTableRequestAction } from 'modules/statistics/types/auditInFiles';

import { createReducer } from 'utils/ReduxUtils';

const initialState: Nullable<string> = null;

const updateFromRequest = (_: Nullable<string>, { payload }: FetchAuditInFilesTableRequestAction): Nullable<string> =>
  payload.request.params.sort ?? null;

export default createReducer(initialState, {
  [types.FETCH_AUDIT_IN_FILES_TABLE_REQUEST]: updateFromRequest,
});
